<template>
<div >
	<Loader :show="loading"></Loader>
	<b-modal id="modalCarForm" :title="title" hide-footer no-close-on-backdrop no-close-on-esc @close="close" size="sm">
		
		<Loader :show="saving"></Loader>

		<b-form @submit.prevent="save" v-if="!loading" novalidate >
			
			<b-form-group label="Cliente" class="mt-4">
				<b-form-select 
					v-model="form.client_id" 
					:options="clients"
					value-field="id"
					text-field="name"
					:state="!validation.hasError('form.client_id')" 
					></b-form-select>
				<b-form-invalid-feedback>Seleccione el cliente</b-form-invalid-feedback>
			</b-form-group>

			<b-form-group label="Tipo de vehículo" class="mt-4">
				<b-form-select 
					v-model="form.category_id" 
					:options="car_categories"
					value-field="id"
					text-field="title"
					:state="!validation.hasError('form.category_id')" 
					></b-form-select>
				<b-form-invalid-feedback>Seleccione la categoria</b-form-invalid-feedback>
			</b-form-group>
			
			<b-form-group label="Marca" class="mt-4">
				<b-form-select 
					v-model="form.brand" 
					:options="brands"
					value-field="id"
					text-field="title"
					:state="!validation.hasError('form.brand')" 
					></b-form-select>
				<b-form-invalid-feedback>Seleccione la marca</b-form-invalid-feedback>
			</b-form-group>

			<b-form-group label="Modelo" class="mt-4" >
				<b-form-input
					v-model="form.model"
					placeholder="Modelo"
					:state="!validation.hasError('form.model')" 
				></b-form-input>
				<b-form-invalid-feedback>Ingrese el modelo</b-form-invalid-feedback>
			</b-form-group>

			<b-form-group label="Color" class="mt-4" >
				<b-form-input
					v-model="form.color"
					placeholder="Color"
					:state="!validation.hasError('form.color')" 
				></b-form-input>
				<b-form-invalid-feedback>Ingrese un color</b-form-invalid-feedback>
			</b-form-group>
			
			<b-form-group label="Numeración interna" class="mt-4" >
				<b-form-input
					v-model="form.internal_number"
					placeholder="Número interno"
				></b-form-input>
				<b-form-invalid-feedback>Ingrese un número</b-form-invalid-feedback>
			</b-form-group>
			
			<b-form-group label="Dua Stock" class="mt-4" >
				<b-form-input
					v-model="form.dua_stock"
					placeholder="Dua stock"
				></b-form-input>
				<b-form-invalid-feedback>Ingrese un número</b-form-invalid-feedback>
			</b-form-group>
			
			<b-form-group label="Número de chasis" class="mt-4" >
				<b-form-input
					v-model="form.chassis_number"
					placeholder="Número de chasis"
					:state="!validation.hasError('form.chassis_number')" 
				></b-form-input>
				<b-form-invalid-feedback>Ingrese el número de chasis</b-form-invalid-feedback>
			</b-form-group>
			
			<b-form-group label="Número de motor" class="mt-4" >
				<b-form-input
					v-model="form.motor_number"
					placeholder="Número de motor"
					:state="!validation.hasError('form.motor_number')" 
				></b-form-input>
				<b-form-invalid-feedback>Ingrese el número de motor</b-form-invalid-feedback>
			</b-form-group>


			<b-form-group label="Depósito" class="mt-4" v-if="!id || car && car.status == 'PRE_ADMITTED'" >
				<b-form-select 
					v-model="form.deposit" 
					:options="[{'id':1 , 'name':'Fiscal'},{'id':2,'name':'Nacional'}]"
					value-field="id"
					text-field="name"
					:state="!validation.hasError('form.deposit')" 
					></b-form-select>
				<b-form-invalid-feedback>Seleccione el depósito</b-form-invalid-feedback>
			</b-form-group>

			
			<div class="overflow-hidden mt-3">
				<b-button type="submit" class="pull-right" size="sm" variant="primary">Guardar cambios</b-button>
			</div>
			
			<!-- <b-button type="button" @click="deletePrompt" block v-if="action=='update'" variant="outline-danger" class="btn-delete mt-4">Eliminar marca</b-button> -->
			
		</b-form>

	</b-modal>	
</div>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Loader from '@/components/Loader'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'CarFormModal',
	components:{
		Loader
	},
	mixins: [mixins],
	data () {
		return {
			title: 'Crear vehículo',
			show: false,
			loading:false,
			saving:false,
			id: null,
			car:null,
			brands: [],
			clients: [],
			car_categories: [],
			form: {
				client_id: null,
				category_id: null,
				deposit: null,
				brand: null,
				model: null,
				color: null,
				internal_number: null,
				dua_stock: null,
				chassis_number: null,
				motor_number: null,
			},
		}
	},
	validators: {
		'form.client_id': function (value) {
			return Validator.value(value).required();
		},
		'form.category_id': function (value) {
			return Validator.value(value).required();
		},
		'form.brand': function (value) {
			return Validator.value(value).required();
		},
		'form.model': function (value) {
			return Validator.value(value).required();
		},
		'form.color': function (value) {
			return Validator.value(value).required();
		},
		'form.chassis_number': function (value) {
			return Validator.value(value).required();
		},
		'form.motor_number': function (value) {
			return Validator.value(value).required();
		},
	},
	methods: {
		open (id=null) {
			this.id = id
			if( id>0 ){
				this.title = 'Editar vehículo'
				this.load()
			}
			this.showModal()
		},
		showModal() {
			this.show = true
			this.fetchData()
			this.$bvModal.show('modalCarForm')
		},
		close () {
			this.show = false
			this.form = {}
			this.$emit('updated')
			this.$bvModal.hide('modalCarForm')
		},
		load(){
			this.$apollo.query({
				query: gql`query getCar($id: ID!) {
					car(id: $id) {
						id
						client{
                            id
							name
                            business_name
                            email
                        }
                        brand{
                            id
							title
                            logo{
								urlThumb
							}
                        }
						model
						category{
							id
							title
							draw
						}
						deposit{
							id
							title
						}
                        motor_number
                        chassis_number
						dua_stock
						internal_number
                        model_particular
                        color{
                            title
                        }
                        status
						statusText
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					id: this.id
				},
			})
			.then((data) => {
				this.car = data.data.car

				this.form.client_id = data.data.car.client.id || null
				this.form.category_id 	= data.data.car.category.id || null
				this.form.brand 	= data.data.car.brand.id || null
				this.form.model 	= data.data.car.model || null
				this.form.color 	= data.data.car.color.title || null
				this.form.deposit 	= data.data.car.deposit.id || null
				
				this.form.chassis_number 	= data.data.car.chassis_number || null
				this.form.motor_number 	= data.data.car.motor_number || null
				this.form.dua_stock 	= data.data.car.dua_stock || null
				this.form.internal_number 	= data.data.car.internal_number || null

				this.loading = false
			})
		},
		fetchData () {
			this.$apollo.query({
				query: gql`query {
					car_brands {
						id
						title
						logo{
							id
							filename
							url
							urlThumb
							type
							size
						}
					}
					clientsAll {
						id
						name
					}
					car_categories {
						id
						title
					}
				}`,
			})
			.then((data) => {
				this.brands = data.data.car_brands;
				this.clients = data.data.clientsAll;
				this.car_categories = data.data.car_categories;
			});
		},
		async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true
				
				let dataInput = {
					client_id		: this.form.client_id,
					category_id		: this.form.category_id,
					brand			: this.form.brand,
					model			: this.form.model,
					color			: this.form.color,
					chassis_number	: this.form.chassis_number,
					motor_number	: this.form.motor_number,
					dua_stock		: this.form.dua_stock,
					internal_number	: this.form.internal_number,
				}

				if(this.id>0){

					if(this.car.status == 'PRE_ADMITTED')dataInput.deposit_id = this.form.deposit

					this.$apollo.mutate({
						mutation: gql`mutation ( $id: ID!, $data:CarInput! ){
							updateCar( id: $id, data: $data) {
								id
							}
						}`,
						variables: {
							id: this.id,
							data: dataInput
						}
					})
					.then(() => {
						this.$toast.success('Vehículo editado')
						this.saving = false
						this.$emit('updated')
						this.close ()

					})
					.catch( (error) => {
						this.errors = this.parseGQLErrors(error)
						this.saving = false
					})
				}else{
					
					dataInput.deposit_id = this.form.deposit
					
					this.$apollo.mutate({
						mutation: gql`mutation ( $data:CarInput! ){
							preloadCar( data: $data) {
								id
							}
						}`,
						variables: {
							data: dataInput
						}
					})
					.then(() => {
						this.$toast.success('Vehículo creado')
						this.saving = false
						this.$emit('updated')
						this.close ()
					})
					.catch( (error) => {
						this.errors = this.parseGQLErrors(error)
						this.saving = false
					})
				}
			}

		},
	}
}


</script>
